import aa from 'search-insights';
import { checkConsent } from '../../../../../utils/checkConsent';
import { APPLICATION_ID, SEARCH_API_KEY } from '../../../searchClient';

export const initInsights = () =>
  aa('init', {
    appId: APPLICATION_ID,
    apiKey: SEARCH_API_KEY,
    useCookie: checkConsent(),
    cookieDuration: 24 * 60 * 60 * 1000, // sets the cookie expiration to 24h for guest users
  });
